import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/user/advanced')({
	component: UserAdvancedPage,
});

function UserAdvancedPage() {
	return <div></div>;
}
